import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard } from "@fortawesome/free-solid-svg-icons";
import shc from "../../assets/images/statistics.png";
import pdmc from "../../assets/images/onboardlogo/pdmc.png";
import nfsm from "../../assets/images/onboardlogo/nfsm.png";
import soilhealth from "../../assets/images/onboardlogo/shc.png";
import aif from "../../assets/images/onboardlogo/AIF.png";
import cropic from "../../assets/images/onboardlogo/cropic.png";
import ACABC from "../../assets/images/onboardlogo/acabc.png"
import RKVY from '../../assets/images/onboardlogo/rkvy.png'
import { Link } from "react-router-dom";
import '../../assets/styles/barhide.css';
import nf from '../../assets/images/onboardlogo/nf.jpg'
import MOVCD from '../../assets/images/onboardlogo/movcd.png'
import seedhub from '../../assets/images/onboardlogo/seedhub.png'
import nfsmnew from '../../assets/images/onboardlogo/nfsmnew.png'
import CHCAppLogo from "../../assets/images/onboardlogo/CHCAppLogo.png";
import powerbimg from "../../assets/images/power_bi.png";
function PowerBi() {
  return (
    <>
      {/* <aside id="myDIV" className="sidebar">
            </aside> */}
      <main id="main" className="main AdminAccess">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Analytic Dashboard</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Analytic Dashboard</li>
            </ol>
          </nav>
          <Link className="btn btn-success backdashbord" to="/AdminAccess"><i class="bi bi-skip-backward"></i> Back</Link>
        </div>
        <div className="container-fluid">

          <div className="card">
            <div className="card-body onbordedSchemess analyticsH schemesreport">

              
            

              <h3>Power Bi</h3>
              <div className='row'>
              <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href ="https://app.powerbi.com/view?r=eyJrIjoiMDBiMTE2NDItMmIzZC00NzUzLWJiZTAtZjhlYjMyZTI5YjgxIiwidCI6IjZlOGUyOGI4LTBhZmUtNGMyNy1hZjI5LTYwMDRmODRjNGY3YSJ9" target="_blank" rel="noopener noreferrer">
                      <div className="card-body"><img src={powerbimg} />
                      </div>
                      <h6>Master Count Dashboard</h6>
                    </a>
                  </div>
                </div>
                 <div className="col-md-2 col-sm-4">
                 <div className="dashboardcard">
                    <a href ="https://app.powerbi.com/view?r=eyJrIjoiNjMzZTUzZGYtMjkwNC00NGNkLTk0OTctNmUyODg3NDc5MzYzIiwidCI6IjZlOGUyOGI4LTBhZmUtNGMyNy1hZjI5LTYwMDRmODRjNGY3YSJ9" target="_blank" rel="noopener noreferrer">
                      <div className="card-body"><img src={powerbimg} />
                      </div>
                      <h6>RKVY DPR Dashboard</h6>
                    </a>
                  </div>
                </div>
              <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://app.powerbi.com/view?r=eyJrIjoiM2U1N2JlMmEtMDg4YS00NDFhLThiOWItMGZjY2UzMzllNmE2IiwidCI6IjZlOGUyOGI4LTBhZmUtNGMyNy1hZjI5LTYwMDRmODRjNGY3YSJ9" target="_blank" rel="noopener noreferrer">
                      <div className="card-body"><img src={powerbimg} />
                      </div>
                      <h6>
                        NMEO-OS Dashboard</h6>
                    </a>

                  </div>
                </div>
        


              </div>
            </div>
          </div>


        </div>
      </main>
    </>
  );
}
export default PowerBi